var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7201 9.27993H9.27993V14.7201C9.27993 15.4267 8.70665 16 8 16C7.29335 16 6.72007 15.4267 6.72007 14.7201V9.27993H1.27993C0.573287 9.27993 0 8.70665 0 8C0 7.29335 0.573287 6.72007 1.27993 6.72007H6.72007V1.27993C6.72007 0.573287 7.29335 0 8 0C8.70665 0 9.27993 0.573287 9.27993 1.27993V6.72007H14.7201C15.4267 6.72007 16 7.29335 16 8C16 8.70665 15.4267 9.27993 14.7201 9.27993Z",
    fill: "#6D28FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAddIcon);
export default __webpack_public_path__ + "static/media/plus-add-icon.612488fa1b599fc56cb9cb20bd4bddf5.svg";
export { ForwardRef as ReactComponent };